/* src/app/modules/shared/components/unauthorized/unauthorized.component.scss */
/*# sourceMappingURL=unauthorized.component.css.map */
